import { FontAwesome5 } from '@expo/vector-icons';
import {
  OEText,
  PanelLayout,
  bc,
  flex,
  height,
  ml,
  mr,
  mt,
  opacity,
  pl,
  position,
  pr,
  pv,
  rounded,
  width,
  zIndex,
} from '@openeducation/oe-it-components';
import { secondaryFontFamily } from '@openeducation/oe-it-themes';
import React from 'react';
import { View } from 'react-native';
import { useTheme } from 'react-native-paper';

// TODO: convert to styled-component
export const PCFeedbackEmptyCard = () => {
  const { colors } = useTheme();
  return (
    <PanelLayout
      width={700}
      height={243}
      padding={24}
      backgroundColor={colors.light1}
      opacityBackground={0.5}
    >
      <View
        style={[flex('align-self-center', 'align-items-center'), width(434)]}
      >
        <View style={[flex('flex-row', 'align-items-center')]}>
          <View
            style={[
              bc(colors.primary),
              pv(4),
              pl(8),
              pr(20),
              rounded(4),
              height(30),
              mr(-8),
              flex('flex-row', 'justify-content-center', 'align-items-center'),
            ]}
          >
            <OEText fontSize={20} fontType="bold" color={colors.white}>
              First
            </OEText>
          </View>
          <View
            style={[
              width(79),
              height(79),
              rounded(40),
              bc(colors.white),
              flex('justify-content-center', 'align-items-center'),
            ]}
          >
            <View
              style={[
                width('100%'),
                height('100%'),
                zIndex(-1),
                opacity(0.1),
                position('absolute'),
                bc(colors.primary),
                rounded(40),
              ]}
            />
            <OEText color={colors.primary} fontSize={32}>
              <FontAwesome5 name="smile-wink" size={32} />
            </OEText>
          </View>
          <View
            style={[
              bc(colors.primary),
              pv(4),
              pr(8),
              zIndex(-1),
              rounded(4),
              height(30),
              pl(20),
              pr(8),
              ml(-8),
              flex('flex-row', 'justify-content-center', 'align-items-center'),
            ]}
          >
            <OEText fontSize={20} fontType="bold" color={colors.white}>
              Class
            </OEText>
          </View>
        </View>
        <View style={[mt(24), width(434)]}>
          <OEText
            textAlign="center"
            fontSize={16}
            fontFamily={secondaryFontFamily}
          >
            It's your student's first private class. Have a great class!
          </OEText>
        </View>
      </View>
    </PanelLayout>
  );
};
